var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookAtBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23 11.01-5-0.01c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-0.99-1-0.99zm0 8.99h-5v-7h5zm-3-18h-18c-1.11 0-2 0.89-2 2v12c0 1.1 0.89 2 2 2h7v2h-2v2h8v-2h-2v-2h2v-2h-13v-12h18v5h2v-5c0-1.11-0.9-2-2-2zm-18.888 6.6944 0.036728 0.020185-0.32282-0.074117-0.13566 0.82696-0.010866-0.037729 0.21055 0.087565 0.51048-0.07418-0.11873-0.23143 0.22852-0.12352 0.15093-0.50159z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookAtBrowser);
export default __webpack_public_path__ + "static/media/look_at_browser.d6a33f4897fc88d3044d7e103c9422cd.svg";
export { ForwardRef as ReactComponent };